const mapboxApi =
  'pk.eyJ1IjoiaGlnb3Jsb3JlbiIsImEiOiJja3l1aXo1eTMxbnRuMm9qamx0aXZ2bm5pIn0.tQpKIz1WD22KpjKVJ4IwUA';

export { mapboxApi };
